angular.module("vgresiduos").controller("IbamaRappIntegrationFollowupCtrl", [
	"$rootScope",
	"$stateParams",
	function ($rootScope, $stateParams) {
		"use strict";

		this.$onInit = function () {
			Vgr.util.redirectSingleton($rootScope, `declaracoes/ibama-rapp/integracao/acompanhamento/${$stateParams.id}`);
		};
	}
]);
